import { Form, Input, Button, Breadcrumb } from 'antd';
import { useResetPassword } from '@hooks/useResetPassword';
import { Container, AuthCard, BreadcrumbWrapper, StyledLink } from '../style';
import { LockOutlined, HomeOutlined, KeyOutlined, SafetyOutlined } from '@ant-design/icons';

const ResetPassword = () => {
    const { form, loading, token, email, onFinish } = useResetPassword();

    const breadcrumbItems = [
        {
            title: (
                <StyledLink to="/sign-in">
                    <HomeOutlined /> Sign In
                </StyledLink>
            )
        },
        {
            title: (
                <StyledLink to="/forgot-password">
                    <KeyOutlined /> Forgot Password
                </StyledLink>
            )
        },
        ...(email ? [{
            title: (
                <StyledLink to={`/otp?email=${email}`}>
                    <SafetyOutlined /> OTP Verification
                </StyledLink>
            )
        }] : []),
        {
            title: ''
        }
    ];

    return (
        <Container>
            <AuthCard 
                title="Reset Password" 
            >
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        name="password"
                        label="New Password"
                        rules={[{ required: true, message: 'Please input your new password!' }]}
                    >
                        <Input.Password size="large" prefix={<LockOutlined />} placeholder="Enter your new password" />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        rules={[{ required: true, message: 'Please confirm your password!' }]}
                    >
                        <Input.Password size="large" prefix={<LockOutlined />} placeholder="Confirm your new password" />
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block loading={loading}>
                            Reset Password
                        </Button>
                    </Form.Item>
                </Form>
            </AuthCard>
            <BreadcrumbWrapper>
                <Breadcrumb items={breadcrumbItems} />
            </BreadcrumbWrapper>
        </Container>
    );
};

export default ResetPassword;
